<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">KARTICA ARTIKLA</h2>
  
  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="dx-field">
        <div class="odabirDatuma">
          <label>Datum od:</label>
          <dx-date-box
            [(value)]="datumOd"
            [(max)]="datumDo"
            pickerType="calendar"
            displayFormat='dd.MM.yyyy.'
            width="200"
            (onValueChanged)="onValueChangedDatumOd($event)">
          </dx-date-box>
        </div>
        <div class="odabirDatuma">
          <label>Datum do:</label>
          <dx-date-box
            [(value)]="datumDo"
            [(min)]="datumOd"
            pickerType="calendar"
            displayFormat='dd.MM.yyyy.'
            width="200"
            (onValueChanged)="onValueChangedDatumDo($event)">
          </dx-date-box>
        </div>
        <div class="odabirDatuma">
          <label [style]="{ 'margin-left': '30px' }">Odabir vrste dokumenta:</label>
          <dx-select-box
            displayExpr="DV_SIFRA"
            valueExpr="DV_SIFRA"
            [dataSource]="sveVrsteDokumenta"
            [(value)]="sifraDokumenta"
            width="200"
            (onValueChanged)="onChangeVrsta($event)"
            [showClearButton]="true"
            [searchEnabled]="true"
            [searchExpr]="['DV_SIFRA', 'DV_NAZIV']"
            [style]="{ 'margin-left': '30px' }">
          </dx-select-box>
        </div>
      </div>
      <div class="dx-field">
        <div class="odabirDatuma">
          <label>Odabir artikla:</label>
          <dx-select-box
            displayExpr="sifrainaziv"
            valueExpr="ar_id"
            [dataSource]="sviArtikli"
            [(value)]="idArtikl"
            width="600"
            (onValueChanged)="onChangeArtikl($event)"
            [showClearButton]="true"
            [searchEnabled]="true"
            [searchExpr]="['ar_sifra', 'ar_naziv']">
            <dx-validator validationGroup="artiklValidacija">
              <dxi-validation-rule type="required" ></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
        <div class="odabirDatuma">
          <label>Odabir skladišta:</label>
          <dx-select-box
            displayExpr="sifrainaziv"
            valueExpr="idposlovnica"
            [items]="skladista"
            [(value)]="idPoslovnica"
            width="500"
            (onValueChanged)="onChangeSkladiste($event)"
            [showClearButton]="true"
            [searchEnabled]="true"
            [searchExpr]="['po_sifra', 'po_naziv']">
          </dx-select-box>
        </div>
        <div class="odabirDatuma">
          <dx-button
            class="btn_trazi"
            [disabled]="disableGumb"
            stylingMode="contained"
            text="Pretraži"
            type="success"
            [width]="120"
            (onClick)="pretrazi()">
          </dx-button>
        </div>
      </div>
    </div>
    <div class="customTable dnevniPlan">
      <dx-data-grid 
        id="tablicaKarticaArtikla" 
        [dataSource]="dokumenti" 
        [wordWrapEnabled]="true" 
        noDataText="{{ poruka }}"
        [showColumnLines]="true"
        [showBorders]="false" 
        [columnAutoWidth]="true" 
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)">

        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Pregled kartica artikala</h2>
          </div>
        </div>

        <dxo-header-filter 
          [visible]="true">
        </dxo-header-filter>

        <dxo-scrolling 
          columnRenderingMode="virtual" 
          [showScrollbar]="'always'">
        </dxo-scrolling>

        <dxo-search-panel 
          [visible]="true" 
          [width]="210" 
          placeholder="Pretraži...">
        </dxo-search-panel>

        <dxo-paging 
          [enabled]="true" 
          [pageSize]="10">
        </dxo-paging>

        <dxo-pager 
          [showPageSizeSelector]="true" 
          [allowedPageSizes]="[10, 20, 30]" 
          [showInfo]="true">
        </dxo-pager>

        <dxi-column 
          dataField="pz_datum" 
          dataType="date" 
          caption="Datum" 
          [width]="130" 
          alignment="center">
        </dxi-column>
        <dxi-column 
          dataField="DV_SIFRA" 
          caption="Vrsta dokumenta" 
          alignment="left">
        </dxi-column>
        <dxi-column 
          dataField="pz_broj" 
          caption="Dokument broj" 
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="pz_broj_vezni" 
          caption="Vezni dokument" 
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="po_sifra" 
          caption="Šifra poslovnice" 
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="po_naziv" 
          caption="Naziv poslovnice" 
          alignment="left">
        </dxi-column>
        <dxi-column 
          dataField="pa_sifra" 
          caption="Šifra partnera" 
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="pa_naziv" 
          caption="Naziv partnera" 
          alignment="left">
        </dxi-column>
        <dxi-column 
          dataField="pp_sifra" 
          caption="Šifra poslovnice partnera" 
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="pp_naziv" 
          caption="Naziv poslovnice partnera" 
          alignment="left">
        </dxi-column>
        <dxi-column 
          dataField="ps_ulaz" 
          caption="Ulaz" 
          [format]="{ type: 'fixedPoint', precision: 3 }"
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="ps_izlaz" 
          caption="Izlaz" 
          [format]="{ type: 'fixedPoint', precision: 3 }"
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="za_stanje" 
          caption="Stanje" 
          [format]="{ type: 'fixedPoint', precision: 3 }"
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="ps_brutocij" 
          caption="Bruto cijena" 
          [format]="{ type: 'fixedPoint', precision: 5 }"
          alignment="right">
        </dxi-column>
        <dxi-column 
          dataField="ps_postorabata" 
          caption="Rabat" 
          alignment="right">
        </dxi-column>
        <dxi-column
          dataField="ps_ulazc"
          caption="Ulazna cijena"
          [format]="{ type: 'fixedPoint', precision: 5 }"
          alignment="right"
          width="160">
        </dxi-column>
        <dxi-column
          dataField="ps_ulazvr"
          caption="Vrijednost ulaza"
          [format]="{ type: 'fixedPoint', precision: 2 }"
          alignment="right"
          width="160">
        </dxi-column>
        <dxi-column
          dataField="ps_izlazc"
          caption="Izlazna cijena"
          [format]="{ type: 'fixedPoint', precision: 5 }"
          alignment="right"
          width="160">
        </dxi-column>
        <dxi-column
          dataField="ps_izlazvr"
          caption="Vrijednost izlaza"
          [format]="{ type: 'fixedPoint', precision: 2 }"
          alignment="right"
          width="160">
        </dxi-column>
        <dxi-column
          dataField="ps_ruc"
          caption="RUC"
          [format]="{ type: 'fixedPoint', precision: 2 }"
          alignment="right"
          width="160">
        </dxi-column>
        <dxi-column
          dataField="ps_nabcij"
          caption="Nab.cijena"
          [format]="{ type: 'fixedPoint', precision: 3 }"
          alignment="right"
          width="160">
        </dxi-column>
        <dxi-column dataField="pz_status" caption="Status" [width]="130" alignment="center">
          <dxo-lookup
            [dataSource]="statusArray"
            displayExpr="status_naziv"
            valueExpr="status_vrijednost">
          </dxo-lookup>
        </dxi-column>
        <dxi-column 
          dataField="uf_broj" 
          caption="Broj računa" 
          alignment="right">
        </dxi-column>

        <dxo-summary *ngIf="dokumenti.length > 0">
          <dxi-total-item 
            column="pp_naziv" 
            summaryType="sum" 
            alignment="left" 
            displayFormat="Ukupno:">
          </dxi-total-item>
          <dxi-total-item
            column="ps_ulaz"
            summaryType="sum"
            alignment="right"
            displayFormat="{0}"
            [valueFormat]="{ type: 'fixedPoint', precision: 3 }">
          </dxi-total-item>
          <dxi-total-item
            column="ps_izlaz"
            summaryType="sum"
            alignment="right"
            displayFormat="{0}"
            [valueFormat]="{ type: 'fixedPoint', precision: 3 }">
          </dxi-total-item>
        </dxo-summary>
      </dx-data-grid>
    </div>

  </div>
</div>